export interface TrainingBenefit {
  id: string;
  name: Record<string, string>;
  description?: Record<string, string>;
  emoji?: string;
  iconUrl?: string;
  isFilterHidden?: boolean;
  position: number;
}

export function trainingBenefitFromMap(map: Record<string, unknown>): TrainingBenefit {
  return {
    id: map['id'] as string,
    name: map['name'] as Record<string, string>,
    description: map['description'] != null
      ? (map['description'] as Record<string, string>)
      : undefined,
    emoji: map['emoji'] as string | undefined,
    iconUrl: map['iconUrl'] as string | undefined,
    isFilterHidden: map['isFilterHidden'] as boolean | undefined,
    position: map['position'] as number,
  };
}

export function benefitNameEn(benefit: TrainingBenefit): string {
  return benefit.name['en'] ?? '';
}
